export enum FMY {
Full,
Half,
None,
}
